/**
 * Configuração dos filtros para a listagem de candidatos
 */
export const filterConfig = [
  // 🔍 Busca geral
  {
    id: 'search',
    type: 'text',
    label: 'Busca geral',
    placeholder: 'Nome, sobrenome, e-mail, CPF ou telefone...'
  },

  // 📋 Filtros básicos de identificação
  { id: 'TituloVaga', type: 'text', label: 'Titulo da Vaga' },
  { id: 'Nome', type: 'text', label: 'Nome' },
  { id: 'Sobrenome', type: 'text', label: 'Sobrenome' },
  { id: 'CPF', type: 'text', label: 'CPF' },
  { id: 'Email', type: 'text', label: 'E-mail' },
  { id: 'NumeroTelefone', type: 'text', label: 'Telefone' },

  // 🎓 Escolaridade
  {
    id: 'Escolaridade',
    type: 'select',
    label: 'Escolaridade',
    placeholder: 'Selecione...',
    options: [
      { label: 'Fundamental', value: 'fundamental' },
      { label: 'Médio', value: 'medio' },
      { label: 'Técnico', value: 'tecnico' },
      { label: 'Superior', value: 'superior' },
      { label: 'Pós-graduação', value: 'pos' },
      { label: 'Mestrado', value: 'mestrado' },
      { label: 'Doutorado', value: 'doutorado' }
    ],
    defaultValue: ''
  },

  // 📍 Localização
  { id: 'EstadoLocalizacao', type: 'text', label: 'Estado' },
  { id: 'CidadeLocalizacao', type: 'text', label: 'Cidade' },
  { id: 'BairroLocalizacao', type: 'text', label: 'Bairro' },
  { id: 'RuaLocalizacao', type: 'text', label: 'Rua' },
  { id: 'CEPLocalizacao', type: 'text', label: 'CEP' },
  { id: 'NumeroLocalizacao', type: 'text', label: 'Número' },

  // 🚗 CNH
  {
    id: 'somenteComCNH',
    type: 'select',
    label: 'Possui CNH?',
    placeholder: 'Selecione...',
    options: [
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' }
    ],
    defaultValue: ''
  },
  { id: 'NumeroCNH', type: 'text', label: 'Número da CNH' },
  {
    id: 'CategoriaCNH',
    type: 'select',
    label: 'Categoria CNH',
    placeholder: 'Selecione...',
    options: [
      { label: 'A', value: 'A' },
      { label: 'B', value: 'B' },
      { label: 'C', value: 'C' },
      { label: 'D', value: 'D' },
      { label: 'E', value: 'E' },
      { label: 'AB', value: 'AB' }
    ],
    defaultValue: ''
  },
  { id: 'validadeCnhInicio', type: 'date', label: 'Validade CNH - Início' },
  { id: 'validadeCnhFim', type: 'date', label: 'Validade CNH - Fim' },

  // 📄 Currículo e anexos
  {
    id: 'somenteComCurriculo',
    type: 'select',
    label: 'Possui currículo anexado?',
    placeholder: 'Selecione...',
    options: [
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' }
    ],
    defaultValue: ''
  },

  // 📅 Datas de criação
  { id: 'dataCriadoInicio', type: 'date', label: 'Data de criação - Início' },
  { id: 'dataCriadoFim', type: 'date', label: 'Data de criação - Fim' },

  // 📄 Outros campos
  { id: 'PIS', type: 'text', label: 'PIS' },

  // 🗑️ Deletados
  {
    id: 'incluirDeletados',
    type: 'select',
    label: 'Incluir candidatos deletados?',
    placeholder: 'Selecione...',
    options: [
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' }
    ],
    defaultValue: ''
  },

  // 🔽 Ordenação
  {
    id: 'sortBy',
    type: 'select',
    label: 'Ordenar por',
    placeholder: 'Selecione...',
    options: [
      { label: 'ID', value: 'id' },
      { label: 'Nome', value: 'Nome' },
      { label: 'Sobrenome', value: 'Sobrenome' },
      { label: 'CPF', value: 'CPF' },
      { label: 'Email', value: 'Email' },
      { label: 'Telefone', value: 'NumeroTelefone' },
      { label: 'Escolaridade', value: 'Escolaridade' },
      { label: 'Cidade', value: 'CidadeLocalizacao' },
      { label: 'Estado', value: 'EstadoLocalizacao' },
      { label: 'Data de criação', value: 'DataCriado' },
      { label: 'Validade CNH', value: 'ValidadeCNH' }
    ],
    defaultValue: ''
  },
  {
    id: 'sortDir',
    type: 'select',
    label: 'Direção da ordenação',
    placeholder: 'Selecione...',
    options: [
      { label: 'Crescente', value: 'asc' },
      { label: 'Decrescente', value: 'desc' }
    ],
    defaultValue: ''
  }
];